import React from "react";
import ScrollToAnchor from "./ScrollToAnchor.jsx";
import Hero from "../../component/Hero/Hero";
import About from "../section/about/about";
import Deals from "../section/deals/deals";
import Newlaunch2 from "../section/newlaunch2/newlaunch2";
import Promo from "../section/promo/promo";
import Produk from "../section/produk/produk";
import Fasilitas from "../../component/fasilitas/fasilitas";
import Surrounding from "../section/surrounding/surrounding.jsx";

const home = () => {
  return (
    <div className="home">
      <ScrollToAnchor />
      <Hero />
      <About />
      <Deals />
      <Newlaunch2 />
      <Promo />
      <Produk />
      <Fasilitas />
      <Surrounding />
    </div>
  );
};

export default home;
